import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { BRAND } from "@/data";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="grain min-h-screen bg-ink flex items-center justify-center px-6 py-16">
      <div className="absolute inset-0 radial-purple pointer-events-none" />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="relative w-full max-w-md"
      >
        <Link to="/" className="flex items-center justify-center gap-3 mb-10" data-testid="auth-brand">
          <img src={BRAND.logo} alt="Peace Trucking" className="h-14 w-14 object-contain" />
          <div className="text-center">
            <div className="font-serif text-2xl text-cream">Peace Trucking</div>
            <div className="text-[10px] tracking-[0.35em] uppercase text-gold/70">Client Portal</div>
          </div>
        </Link>

        <div className="bg-ink-2 border border-gold/15 p-8 lg:p-10">
          <h1 className="font-serif text-3xl text-cream font-light">{title}</h1>
          <p className="mt-2 text-cream/55 font-light text-sm">{subtitle}</p>
          <div className="mt-8">{children}</div>
        </div>

        <div className="mt-6 text-center text-sm text-cream/50">{footer}</div>
      </motion.div>
    </div>
  );
}

export const authField =
  "w-full bg-ink border border-gold/20 px-4 py-3 text-cream placeholder:text-cream/30 focus:outline-none focus:ring-2 focus:ring-gold/60 transition";
export const authBtn =
  "w-full btn-gold border border-gold text-gold py-4 tracking-widest text-sm flex items-center justify-center gap-2 disabled:opacity-60";
